export default __webpack_public_path__ + "images/erickson-living-knockout.svg?23040c417e3ba31df4b77c13326e9291";